import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import {
  parseCsvLocalDateTime,
  parseNullableBooleanValue,
} from '~/prix/utils/bulk/csvValueParsers'

const family: Dataset = {
  schema: 'public_health',
  table: 'family',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    residence_code: original => original,
    responsible_family_member_cpf: original => original,
    responsible_family_member_cns: original => original,
    moved: original => parseNullableBooleanValue(original as string),
    created_at: original => parseCsvLocalDateTime(original as string),
    updated_at: original => parseCsvLocalDateTime(original as string),
  },
}

export default family
